var $0d17809e74607796$exports = {};
$0d17809e74607796$exports = {
    "dropzoneLabel": `Zona di rilascio`,
    "selectPlaceholder": `Seleziona un elemento`,
    "tableResizer": `Ridimensionamento`
};


export {$0d17809e74607796$exports as default};
//# sourceMappingURL=it-IT.module.js.map
